import { MainSection } from "@/styles/global";
import React from "react";
import S from "./TextBoxes.styled";

export type TextBoxesProps = {
  title: string;
  textBoxes: {
    boxTitle: string;
    text: string;
  }[];
};

const TextBoxes: React.FC<TextBoxesProps> = ({ title, textBoxes }) => {
  const renderCards = textBoxes?.map(({ boxTitle, text }, index) => {
    return (
      <S.Card key={index}>
        <S.CardTitle>{boxTitle}</S.CardTitle>
        <S.Text>{text}</S.Text>
      </S.Card>
    );
  });

  return (
    <MainSection>
      <S.Inner>
        {title && <S.Title>{title}</S.Title>}
        <S.CardsWrapper>{renderCards}</S.CardsWrapper>
      </S.Inner>
    </MainSection>
  );
};

export default TextBoxes;
